/**
 * Global Token Store - Singleton pattern
 * Access token: memory + sessionStorage (tab session; refresh cookie restores longer sessions)
 */
const STORAGE_KEY = 'tamcare_access_token';

class TokenStore {
  constructor() {
    this.token = null;
    this.listeners = [];
  }

  readStoredToken() {
    try {
      const stored = sessionStorage.getItem(STORAGE_KEY);
      return stored && typeof stored === 'string' ? stored : null;
    } catch {
      return null;
    }
  }

  getToken() {
    if (this.token) return this.token;
    const stored = this.readStoredToken();
    if (stored) {
      this.token = stored;
    }
    return this.token;
  }

  setToken(token) {
    const next = token && typeof token === 'string' ? token : null;
    this.token = next;
    try {
      if (next) sessionStorage.setItem(STORAGE_KEY, next);
      else sessionStorage.removeItem(STORAGE_KEY);
    } catch {
      // ignore private mode / blocked storage
    }
    this.notifyListeners();
  }

  clearToken() {
    this.setToken(null);
  }

  subscribe(listener) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener);
    };
  }

  notifyListeners() {
    this.listeners.forEach((listener) => listener(this.token));
  }
}

const tokenStore = new TokenStore();

export default tokenStore;
